<template>
  <div class="free-bets__wrapper">
    <div :class="activeId ? '' : 'active'" class="play__cash" @click="onClickSelect({ id: 0 })">
      <div class="dote__wrapper">
        <div class="dote__box">
          <div class="dote__active"></div>
        </div>
      </div>
      <div class="play__cash_text">{{ $t('real_money', { currencyCode: getFormatedCurrency }) }}</div>
    </div>
    <div class="select__free-bets_wrapper">
      <div v-if="!isArchiveFreeBets" class="select__free-bets_title">
        {{ $t('archive_prize', { prize: currentPrize }) }}
      </div>
      <div v-if="isArchiveFreeBets" class="select__free-bets_title">{{ $t('archive') }}</div>
      <div class="select__free-bets_bets" @click="onClickToggleFreeBets">
        <div class="select__free-bets_img">
          <img :src="getLinkArchive" alt="archive" />
        </div>
        <div class="select__free-bets_text">
          {{ getTextToggle }}
        </div>
      </div>
    </div>
    <div v-if="isSomeFreeBets" class="freeBets__labels_wrapper">
      <div class="freeBets__dot"></div>
      <div class="freeBets__label_item">{{ $t('amount') }}</div>
      <div class="freeBets__label_item">{{ $t('bet') }}</div>
      <div v-if="!isArchiveFreeBets" class="freeBets__label_item">{{ $t('time_is_over') }}</div>
      <div v-if="isArchiveFreeBets" class="freeBets__label_item">{{ $t('win_amount') }}</div>
    </div>
    <div v-if="!isSomeFreeBets" class="freeBets_absent">
      <div class="freeBets_absent_item">{{ $t('freebet.popup.no_free_bet_1') }}</div>
      <div class="freeBets_absent_item">{{ $t('freebet.popup.no_free_bet_2') }}</div>
    </div>
    <div class="freeBets-list">
      <template v-if="!isArchiveFreeBets">
        <ActiveFreeBet
          v-for="spin in getActiveFreeBetSpins"
          :key="spin.id"
          :activeId="activeId"
          :spin="spin"
          @onClickSelect="onClickSelect"></ActiveFreeBet>
      </template>
      <template v-if="isArchiveFreeBets">
        <ArchiveFreeBet v-for="spin in getArchiveFreeBetSpins" :key="spin.id" :spin="spin"></ArchiveFreeBet>
      </template>
    </div>
    <div class="popup_button_ok custom_close_btn" @click="onCloseClick">
      <defaultButton :text="btnCloseText" />
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { Utils } from '@/utils/Utils';
import ActiveFreeBet from '@/components/welcome_popup/tabWelcome/freeBetsItems/ActiveFreeBet.vue';
import ArchiveFreeBet from '@/components/welcome_popup/tabWelcome/freeBetsItems/ArchiveFreeBet.vue';
import defaultButton from '@/components/otherComponents/DefaultButton.vue';
import { IFreeBetSpin } from '@/store/defaultObjects';

export default Vue.extend({
  name: 'WelcomeFreeBets',
  data: () => ({
    isArchiveFreeBets: false
  }),
  components: {
    ActiveFreeBet,
    ArchiveFreeBet,
    defaultButton
  },
  props: {
    activeId: {
      type: Number,
      required: true
    }
  },
  watch: {
    getActiveFreeBetSpins: function (): void {
      if (!this.getActiveFreeBetSpins.find((spin: IFreeBetSpin) => spin.id === this.activeId)) {
        this.$emit('onClickSelect', { id: 0 });
      }
    }
  },
  methods: {
    onClickSelect(data: { id: number }): void {
      this.$emit('onClickSelect', data);
    },
    onClickToggleFreeBets(): void {
      this.isArchiveFreeBets = !this.isArchiveFreeBets;
    },
    getBetSpin(bet: number, decimals: number, code: string): string {
      // TODO: check if used anywhere
      return Utils.centsToMoneyStr(bet, decimals, code) + ` ${code}`;
    },
    onCloseClick(): void {
      this.$emit('selectFreeBet');
    }
  },
  created: function () {
    // @ts-ignore
    this.$parent.$on('closePopup', this.updateValue);
  },
  computed: {
    ...mapGetters([
      'getFreeBetSpins',
      'getArchiveFreeBetSpins',
      'getActiveFreeBetSpins',
      'hasFreeBet',
      'getFreeBetCurrencyCode',
    ]),
    btnCloseText(): string {
      return <string>this.$i18n.t('choose') || '';
    },
    getTextToggle(): string {
      return this.isArchiveFreeBets ? <string>this.$i18n.t('back') : <string>this.$i18n.t('archive');
    },
    getLinkArchive(): string {
      return `${__PROMO_CONFIG.STATIC_URL}/assets/img/freeBets/archive.png`;
    },
    isSomeFreeBets(): boolean {
      return (
        (this.isArchiveFreeBets && this.getArchiveFreeBetSpins.length) ||
        (!this.isArchiveFreeBets && this.getActiveFreeBetSpins.length)
      );
    },
    currentPrize(): string {
      return this.hasFreeBet ? <string>this.$i18n.t('freebet.title') : '';
    },
    getFormatedCurrency(): string {
      return Utils.formatCurrencyCodeToMili(this.getFreeBetCurrencyCode);
    },
  }
});
</script>

<style lang="scss" scoped>
.free-bets__wrapper {
  padding-top: 20px;
  font-size: 26px;
}

.play__cash {
  display: flex;
  align-items: center;
  background-color: #141414;
  border-radius: 23px;
  cursor: pointer;
  border: 2px solid rgba(150, 255, 0, 0);
  transition: all 0.3s ease;
  margin-bottom: 10px;

  &:hover {
    background-color: #000;
  }

  &.active {
    border: 2px solid rgba(150, 255, 0, 1);
    background-color: #252628;

    .dote__active {
      width: 10px;
      height: 10px;
    }
  }
}

.play__cash_text {
  margin-left: 20px;
}

.select__free-bets_wrapper {
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.select__free-bets_title {
  font-size: 30px;
}

.select__free-bets_bets {
  display: flex;
  align-items: center;
  border-radius: 16px;
  background-color: #252628;
  padding: 5px 10px;
  cursor: pointer;

  &:hover {
    .select__free-bets_text {
      color: white;
    }
  }
}

.select__free-bets_img {
  margin-right: 10px;
}

.select__free-bets_text {
  font-size: 20px;
  transition: all 0.2s ease;
  color: #6b6c70;
  letter-spacing: 1px;
}

.freeBets__labels_wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #6b6c70;
}

.freeBets-list {
  height: 100%;
  overflow: auto;
  padding-right: 10px;
}

.freeBets_absent {
  margin-top: 20px;
  font-size: 35px;
}

.freeBets_absent_item {
  text-align: center;
  margin-bottom: 5px;
}
</style>
